import Enums from "../../../src/enums/enums";
import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetContactSearchFirst(contactFinanceType) {
    let _input = {
      contactFinanceType: contactFinanceType,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/GetContactSearchFirst", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactSearchWithSearchText(searchText, contactFinanceType) {
    let _input = {
      searchText: searchText,
      contactFinanceType: contactFinanceType,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/GetContactSearchWithSearchText", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactByContactIdList(contactIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactIdList: contactIdList,
      language: i18n.locale,
    };
    return API.peakAPI
      .post("/api/Contact/GetContactByContactIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactByContactCodeList(contactCodeList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactCodeList: contactCodeList,
      language: i18n.locale,
    };
    return API.peakAPI
      .post("/api/Contact/GetContactByContactCodeList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactByContactTaxList(contactTaxIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactTaxList: contactTaxIdList,
      language: i18n.locale,
    };
    return API.peakAPI
      .post("/api/Contact/GetContactByContactTaxList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantMonitoringAR() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetMerchantMonitoringAR", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetMerchantMonitoringAP() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetMerchantMonitoringAP", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoSetMerchantMonitoringAR(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      followingList: followingList,
    };
    return API.peakAPI
      .post("/api/DashBoard/SetMerchantMonitoringAR", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetMerchantMonitoringAP(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      followingList: followingList,
    };
    return API.peakAPI
      .post("/api/DashBoard/SetMerchantMonitoringAP", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateContact(contact, isAllowCreateContactDuplicate) {
    let _input = {
      contact: contact,
      isAllowCreateContactDuplicate: isAllowCreateContactDuplicate,
    };
    return API.peakRealTimeAPI.post("/api/Contact/CreateContact", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoImportContact(contactList, isAllowCreateContactDuplicate) {
    let _input = {
      contactList: contactList,
      isAllowCreateContactDuplicate: isAllowCreateContactDuplicate,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Contact/CreateContactMultiple", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditContact(contact) {
    let _input = {
      contact: contact,
    };
    return API.peakRealTimeAPI.post("/api/Contact/EditContact", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDefaultContactTemplateFromRd() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/GetDefaultContactTemplateFromRd", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSearchContactTemplateFromRd(searchText) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchText: searchText,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/GetSearchContactTemplateFromRd", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestContactCode(contactFinanceType) {
    let _input = {
      contactFinanceType: contactFinanceType,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/GetSuggestContactCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSearchedContactAddress(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxId: input.taxId,
      branchCode: input.branchCode,
    };

    return API.peakRealTimeAPIForImport
      .post("/api/Contact/GetSearchedContactAddress", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactDetailByid(contactId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/GetContactDetailByid", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateCanDeleteContact(contactId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/ValidateCanDeleteContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactFile(contactId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
    };
    return API.peakRealTimeAPI.post("/api/File/GetContactFile", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUploadContactFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/UploadContactFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteContactFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/DeleteContactFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactWhtTypeSuggestWhtPercentsList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI
      .post("/api/Contact/GetContactWhtTypeSuggestWhtPercents", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateFavoriteContact(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      favoriteTypeId: input.favoriteTypeId,
    };
    return API.peakAPI.post("/api/Contact/UpdateFavoriteContact", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteFavoriteContact(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      financeTypeId: input.financeTypeId,
    };
    return API.peakAPI.post("/api/Contact/DeleteFavoriteContact", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFavoriteContact(financeTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeTypeId: financeTypeId,
    };
    return API.peakAPI.post("/api/Contact/GetFavoriteContact", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoInsertContactGroup(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactGroupModel: input,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/InsertContactGroup", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditContactGroup(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactGroupModel: input,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/EditContactGroup", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteContactGroup(contactGroupId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactGroupId: contactGroupId,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/DeleteContactGroup", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoAssignContactToGroup(assignContactToGroupModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assignContactToGroupModel: assignContactToGroupModel,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/AssignContactToGroup", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteContactFromContactGroup(contactInput) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactInput: contactInput,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/DeleteContactFromContactGroup", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactPersonList(contactId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/GetContactPersonList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertContactPerson(contactId, contactPersonDetailModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
      contactPersonDetailModel: contactPersonDetailModel,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/InsertContactPerson", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditContactPerson(contactPersonDetailModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactPersonDetailModel: contactPersonDetailModel,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/EditContactPerson", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateIsMainPersonByContactPersonId(contactDetail) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactDetail.contactId,
      contactPersonId: contactDetail.contactPersonId,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/UpdateIsMainPersonByContactPersonId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateIsArchivedContactPerson(contactPerson) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isArchived: contactPerson.isArchived,
      contactPersonId: contactPerson.contactPersonId,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/UpdateIsArchivedContactPerson", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateIsArchivedContact(contact) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isArchived: contact.isArchived,
      contactId: contact.contactId,
    };
    return API.peakRealTimeAPI
      .post("/api/Contact/UpdateIsArchivedContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteContactPerson(contactPersonId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactPersonId: contactPersonId,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/DeleteContactPerson", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteContact(contactId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
    };

    return API.peakRealTimeAPI.post("/api/Contact/DeleteContact", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetContactDashboradList(contactDashboard) {
    let transactionTypeId = contactDashboard.transactionTypeId;
    switch (contactDashboard.transactionTypeId) {
      case Enums.TransactionTypeForDashboardContact.PurchaseOrder:
        transactionTypeId = Enums.TransactionType.Quotation;
        break;
      case Enums.TransactionTypeForDashboardContact.PurchaseInventoryRecord:
        transactionTypeId = Enums.TransactionType.Invoice;
        break;
      case Enums.TransactionTypeForDashboardContact.ExpenseRecord:
        transactionTypeId = Enums.TransactionType.Invoice;
        break;
      case Enums.TransactionTypeForDashboardContact.PurchaseAsset:
        transactionTypeId = Enums.TransactionType.Invoice;
        break;
      case Enums.TransactionTypeForDashboardContact.CombinedPaymentNote:
        transactionTypeId = Enums.TransactionType.BillingNote;
        break;
      case Enums.TransactionTypeForDashboardContact.CreditNote:
        transactionTypeId = Enums.TransactionType.CreditNote;
        break;
      case Enums.TransactionTypeForDashboardContact.DebitNote:
        transactionTypeId = Enums.TransactionType.DebitNote;
        break;
    }
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchCriteria: {
        contactId: contactDashboard.contactId,
        transactionType: transactionTypeId,
        financeType: contactDashboard.financeTypeId,
        transactionItemType: contactDashboard.expenseTypeId,
        status: contactDashboard.status,
        pageNo: contactDashboard.pageNo,
        pageSize: contactDashboard.pageSize,
      },
    };

    return API.peakAPI
      .post("/api/Table/GetTransactionTableByContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactDashboardPaymentTotal(contactId) {
    let _input = {
      contactId: contactId,
    };

    return API.peakAPI
      .post("/api/Contact/GetContactDashboardTotalSalesIncome", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactCreditLimit(contactId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: contactId,
    };

    return API.peakRealTimeAPI
      .post("/api/Contact/GetContactCreditLimit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
